import { render, staticRenderFns } from "./resultItem.vue?vue&type=template&id=96d8dc92&scoped=true&"
import script from "./resultItem.vue?vue&type=script&lang=js&"
export * from "./resultItem.vue?vue&type=script&lang=js&"
import style0 from "./resultItem.vue?vue&type=style&index=0&id=96d8dc92&scoped=true&lang=scss&"
import style1 from "./resultItem.vue?vue&type=style&index=1&id=96d8dc92&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96d8dc92",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangmin/Projects/devidia_projects/devidia-p1-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('96d8dc92')) {
      api.createRecord('96d8dc92', component.options)
    } else {
      api.reload('96d8dc92', component.options)
    }
    module.hot.accept("./resultItem.vue?vue&type=template&id=96d8dc92&scoped=true&", function () {
      api.rerender('96d8dc92', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/taskMgr/patrolWorkOrderMgr/components/resultItem.vue"
export default component.exports